/**
 * Called whenever any API request receives a 401 Unauthorized response.
 * Clears the stored auth token and redirects the user to the login page.
 */
export function handleUnauthorized(): void {
  localStorage.removeItem('authTokens');
  // HashRouter uses /#/route — redirect there so the router picks it up.
  window.location.replace('/#/login');
}
